import {
    BannersEditMassActions,
    CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR,
    ON_OPEN_MASS_ACTIONS_PIXEL
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { CHANGE_PIXEL_VALUE, CpmBannerActions } from '../../../actions/banners-edit/cpm-banner';
import { BannersEditMassActionsState, MassActionId } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsPixelReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions | CpmBannerActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR:
            return {
                ...bannersEditMassActionsInitialState,
                [action.massActionId]: {
                    ...bannersEditMassActionsInitialState[action.massActionId],
                    data: {
                        ...state[action.massActionId].data
                    }
                }
            };
        case ON_OPEN_MASS_ACTIONS_PIXEL:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        pixelEditorVisible: true
                    }
                }
            };
        case CHANGE_PIXEL_VALUE:
            if (action.bannerId !== MassActionId.bannersEdit) {
                return { ...state };
            }

            return {
                ...state,
                [action.bannerId]: {
                    ...state[action.bannerId],
                    data: {
                        ...state[action.bannerId].data,
                        pixel: action.value
                    }
                }
            };
        case CLOSE_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        default:
            return state;
    }
}
